export const UPDATE_DATE_FROM = 'UPDATE_DATE_FROM';
export const UPDATE_DATE_TO = 'UPDATE_DATE_TO';
export const SELECTED_CONSULTANCY = 'SELECTED_CONSULTANCY';
